import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { AddGroupDialog } from "../../group/add/add-group-dialog"
import { addGroupToProject } from "../../controller/add-group-to-project"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { navigateGroup } from "../../utilities/project-navigation"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function AddGroup({ variant }) {
    const openGroupDialog = useDialog(<AddGroupDialog />)
    const { target } = useBoundContext()
    const { phase, id: projectId } = target ?? {}
    return (
        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
            <Button
                variant={variant}
                startIcon={<Iconify icon="ic:round-add" />}
                onClick={() => addGroup({ openGroupDialog, projectId })}
                data-cy="add-group-button"
                disabled={isLockedToLegacy(phase)}
            >
                Create New Group
            </Button>
        </Secure>
    )
}

async function addGroup({ openGroupDialog, projectId }) {
    const groupData = await openGroupDialog()
    try {
        if (groupData?.name && groupData?.type) {
            const newGroup = await addGroupToProject({ projectId, name: groupData?.name, type: groupData?.type })
            if (newGroup) {
                successSnackbar("Group added successfully")
                navigateGroup({ projectId, groupId: newGroup?.id })
            } else {
                errorSnackbar("Failed to add group")
            }
        }
    } catch (e) {
        errorSnackbar("Failed to add group")
    }
}
